const patientCareRouteList = {
    patientBooking: "patient-booking",
    patientRegistration: "patient-registration",
    patientEnounter: "patient-encounter",
    patientRegistrationForm: "patient-registration-form",
    emr: "emr",
    emrList:"emr-listing",
    emrDetails: "emr-details",
    nursingVitals: "nursing-vitals",
    nursingVitalsDetails: "nursing-vitals-details",
    nursingTriage: "nursing-triage",
    nursingProcedure: "nursing-procedure",
    billing: "billing",
    billingDetails: "billing-details",
    payment: "payment",
    paymentv1: "payment-v1",
    paymentv2: "payment-v2",
    paymentDetails: "payment-details-view",
    patientLedgerDetails: "patient-ledger-details",
    patientDetailsHistory: "patient-details-history",
    doctorQueue: "doctor-queue",
}

export default patientCareRouteList